import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import styled from 'styled-components';

import SuccessPage from '../components/pages/SuccessPage';
import ErrorPage from '../components/pages/ErrorPage';
import ManagementContainer from './ManagementContainer';
import WizardContainer from './WizardContainer';
import { fetchAndSelectDevice } from '../actions/device';
import { getUserInfo } from '../actions/user';
import { wizardError } from '../actions/wizard';
import OATResults from '../components/pages/OATResults';

const Wrapper = styled.div`
  text-align: center;
  margin-top: 50px;
  font-size: 16px;
  color: ${props => props.theme.primary};
`;

class LoaderContainer extends Component {
  componentDidMount() {
    // Clear errors
    this.props.wizardError(null);
    this.props.getUserInfo();

    const deviceId = this.props.match.params.deviceId;

    if (deviceId == null) {
      this.props.wizardError({ title: 'errors.scan_device_qr' });
    }

    // Check if deviceId provided by persistence layer differs from current
    if (
      (this.props.deviceId !== null && this.props.deviceId !== deviceId) ||
      (deviceId && !this.props.devices[deviceId])
    ) {
      this.props.fetchAndSelectDevice(deviceId);
    }
  }

  userRoleIsAllowed(roles) {
    const intersect = roles.filter(role =>
      this.props.allowedRoles.includes(role)
    );
    return intersect.length > 0;
  }

  render() {
    const {
      target,
      error,
      t,
      user,
      done,
      doneMessage,
      showOATResultPage,
    } = this.props;

    // we can't continue until we know user groups, so we need to wait
    // and can't render anything else than this
    if (!user.groups) {
      return <Wrapper>{t('messages.loading')}</Wrapper>;
    }

    if (!this.userRoleIsAllowed(user.roles)) {
      if (showOATResultPage) {
        return <Wrapper>{t('messages.allowed_roles_OAT')}</Wrapper>;
      } else {
        return <Wrapper>{t('messages.allowed_roles')}</Wrapper>;
      }
    }

    if (done) {
      return <SuccessPage message={doneMessage} />;
    }

    if (error) {
      return (
        <ErrorPage
          title={error.title}
          hint={error.hint}
          showDeviceInput={error.showDeviceInput}
        />
      );
    }

    if (!target) {
      return <Wrapper>{t('messages.loading')}</Wrapper>;
    }

    if (showOATResultPage) {
      return <OATResults />;
    } else if (
      target.lifeCycleStatus === 'OPERATIONAL' ||
      target.lifeCycleStatus === 'RETIRED' ||
      target.lifeCycleStatus === 'READY'
    ) {
      return <ManagementContainer isRoot={user.isRoot} />;
    } else {
      return <WizardContainer />;
    }
  }
}

const mapStateToProps = ({ wizard, device, user }) => ({
  error: wizard.error,
  devices: device.devices,
  target: device.target ? device.devices[device.target] : null,
  ...user,
  done: wizard.done,
  doneMessage: wizard.doneMessage,
});

const mapDispatchToProps = {
  fetchAndSelectDevice,
  getUserInfo,
  wizardError,
};

export default translate()(
  connect(mapStateToProps, mapDispatchToProps)(LoaderContainer)
);
